import React from 'react';
import { Box } from '@mui/material';
import { mobileShellGraphBackdropSx } from '../../../utils/mobilePageShell';
import { LOGIN_ACCENT } from '../../auth/loginDarkTheme';

/** Login-matching grid + glow layer for the native mobile app shell (absolute within shell root). */
export default function MobileShellGraphBackdrop() {
  return (
    <>
      <Box aria-hidden className="mobile-shell-graph-backdrop" sx={mobileShellGraphBackdropSx} />
      <Box
        aria-hidden
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          bottom: '-8%',
          left: '-18%',
          width: 240,
          height: 240,
          borderRadius: '50%',
          filter: 'blur(60px)',
          zIndex: 0,
          background: 'radial-gradient(circle, rgba(45, 212, 191, 0.2) 0%, transparent 70%)',
        }}
      />
      <Box
        aria-hidden
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          top: '38%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 320,
          height: 120,
          borderRadius: '50%',
          filter: 'blur(70px)',
          zIndex: 0,
          opacity: 0.55,
          background: `radial-gradient(circle, ${LOGIN_ACCENT}18 0%, transparent 72%)`,
        }}
      />
    </>
  );
}
